"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServerCultureProvider = void 0;
var _react = require("react");
var _contexts = require("../contexts");
var _utils = require("../utils");
var _LegacyCulture = require("./LegacyCulture");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Server-side culture settings provider.
 *
 * Stores selected language, culture settings, financial settings and timezome identification.
 *
 * @see {@link ServerCultureProviderProps} for the available props and options.
 * @example
  // basic usage
  import { ServerCultureProvider, type ServerCultureProviderProps } from '@ori/culture';

  export function pageRender({cultureSettings, language}: ServerCultureProviderProps) {
    return (
      ...
        <ServerCultureProvider
          cultureSettings={cultureSettings}
          language={language}
        >
          ...
            // Page
          ...
        </ServerCultureProvider>
      ...
    );
  };
 */
const ServerCultureProvider = ({
  children,
  language,
  cultureSettings,
  renderLegacyCulture
}) => {
  const value = (0, _react.useMemo)(() => (0, _utils.cultureSettingsToCultureContext)(cultureSettings, language), [cultureSettings, language]);
  if (renderLegacyCulture) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_contexts.CultureProvider, {
      value: value,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LegacyCulture.LegacyCulture, {
        ...value
      }), children]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.CultureProvider, {
    value: value,
    children: children
  });
};
exports.ServerCultureProvider = ServerCultureProvider;
//# sourceMappingURL=ServerCultureProvider.js.map